
export class Helper {
  static isNextStep: boolean;
  static completedForms = [];
  static applicationObj: any = {
    journeyType: '',
    customerType: '',
    staffId: "",
    arnRef: "",
    isRetrieve: false,
    products: {

    },
    customerInfo: {

    },
    dataFromApplicationPage: {},
    dataAfterRetrieve: {},
    msCode: "",
    errorMsg: '<h3 class="text-danger text-center">We are currently facing some technical difficulties. Please try again after some time. Apologies for any inconvenience caused.</h3>'
  }
  static ripHiddenFields = [];

  static createDocUploadMsg(msg, msgType) {
    return '<span class="text-' + msgType + '"><strong>' + msg + '</strong></span>';
  }

  static enableSpinner(flag: boolean) {
    let spinnerValue = flag ? 'block' : 'none';
    document.getElementById('spinnerComp').style.display = spinnerValue;
  }

  static getAELCompany(prefillData, aelList) {
    let name = prefillData['employer'];
    let prefillAelCode = prefillData['aelCode'] ? prefillData['aelCode'].trim() : '9998';
    if (prefillAelCode == '9998') {
      return '';
    }
    let employerVal = aelList[aelList.findIndex(x => {
      let codeIndex;
      if (x && x.code) {
        codeIndex = x.code.indexOf(prefillAelCode);

        if (codeIndex == 0) {
          return x.code.length == prefillAelCode.length;
        }
        else {
          return codeIndex != -1;
        }
      }

    })];
    return employerVal;
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/utitlity/helper.ts